import React from "react";
import SetDiscountModal from "../../components/cruise/setDiscountModal"
import DetailDescount from "./detailDescount";
import { Link } from "react-router-dom";

export default function GeneralRateCell(props) {
  const handleClick = (open) => {
    return <SetDiscountModal stateSpace={props.space} open={open} />
  }
  return (
    <>
      {(props.user.role == "admin" && props.space.special_discount_price == 0.00) ? (
        <>
          <SetDiscountModal stateSpace={props.space} />
        </>
      ) : (
        <>
          <SetDiscountModal stateSpace={props.space} />
          <DetailDescount stateSpace={props.space} />
        </>
      )}
    </>
  )
}